/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/5
 */
import {createStore, applyMiddleware, compose} from 'redux';
import createSagaMiddleware from 'redux-saga'
import reducers from '../reducers';
import {reduxMiddleware} from '../routes/history';
import saga from '../sagas';
import { getUserInfo } from '../services/user'
import storage from '../utils/sessionStorage';

const sagaMiddleware = createSagaMiddleware();

// process.env.NODE_ENV !== 'production'
const composeEnhancers =  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose;

/**
 * init userInfo
 * @return {*}
 */
const getInitStore = () => {
  const initStore = {};
  const userInfo = getUserInfo();
  const step = storage.getItem('stepData');
  if (userInfo) {
    initStore.user = { userInfo }
  }
  if (step) {
    initStore.step = step;
  }
  return initStore;
};

const store = createStore(
  reducers,
  getInitStore(),
  composeEnhancers(
    applyMiddleware(reduxMiddleware, sagaMiddleware)
  )
);

sagaMiddleware.run(saga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js